import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { AlfaApiLoanApplications } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${AlfaApiLoanApplications.Pages.ALFA_API_LOAN_APPLICATIONS}/:id(\\d+)`,
    name: AlfaApiLoanApplications.Pages.ALFA_API_LOAN_APPLICATIONS,
    component: () => import(/* webpackChunkName: "alfa-api-loan-application" */ './views/AlfaApiLoanApplication.vue'),
    meta: {
      access_roles: RouteRoles[AlfaApiLoanApplications.Pages.ALFA_API_LOAN_APPLICATIONS],
    },
  },
];

export default routes;
